// Environment configuration
export const config = {
  // Environment
  env: process.env.REACT_APP_ENV || 'DEV',
  
  // API Configuration
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  
  // App Configuration
  appName: process.env.REACT_APP_APP_NAME || 'Governate Cloud Admin',
  version: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Feature flags
  features: {
    enableNotifications: process.env.REACT_APP_ENABLE_NOTIFICATIONS !== 'false',
    enableBiometric: process.env.REACT_APP_ENABLE_BIOMETRIC !== 'false',
  },
  
  // Development helpers
  isDevelopment: process.env.REACT_APP_ENV === 'DEV' || process.env.NODE_ENV === 'development',
  isProduction: process.env.REACT_APP_ENV === 'PROD' || process.env.NODE_ENV === 'production',
};

// Validate required environment variables
export const validateConfig = () => {
  const requiredVars = ['REACT_APP_API_URL'];
  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.warn('Missing environment variables:', missing);
  }
  
  return missing.length === 0;
};

// Auto-validate on import
validateConfig();

// Debug logging in development
if (process.env.NODE_ENV === 'development') {
  console.log('Environment config loaded:', {
    env: config.env,
    isDevelopment: config.isDevelopment,
    isProduction: config.isProduction,
    apiUrl: config.apiUrl,
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_ENV: process.env.REACT_APP_ENV
  });
}

export default config;
